// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabCmpConsentExplTitulo extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_consent_expl_titulo";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpConsentExplTitulo {
        this.VALUES ??= this.completar({
            "valor": {
                "ca-ES": "Empreses que utilitzen el consentiment explícit de l'usuari",
                "cz": "Společnosti, které používají výslovný souhlas uživatele",
                "da": "Leverandører, der bruger udtrykkeligt samtykke fra brugeren",
                "de": "Unternehmen, die die ausdrückliche Zustimmung des Benutzers verwenden",
                "en": "Vendors that use the explicit consent of the user",
                "eu-ES": "Erabiltzailearen baimen esplizitua erabiltzen duten enpresak",
                "fi": "Toimittajat, jotka käyttävät käyttäjän nimenomaista suostumusta",
                "fr": "Partenaires qui utilisent le consentement explicite de l\\'utilisateur",
                "ga-ES": "Empresas que utilizan o consentimento explícito do usuario",
                "hi": "उपयोगकर्ता की स्पष्ट सहमति का उपयोग करने वाले विक्रेता",
                "hu": "Azok a szállítók, amelyek a felhasználó kifejezett beleegyezését használják",
                "it": "Società che usano il consenso esplicito dell\\'utente",
                "no": "Leverandører som bruker uttrykkelig samtykke fra brukeren",
                "nl": "Bedrijven die de expliciete toestemming van de gebruiker gebruiken",
                "pl": "Firmy, które wykorzystują wyrażoną zgodę użytkownika",
                "pt": "Empresas que utilizam o consentimento explícito do utilizador",
                "pt-BR": "Empresas que usam o consentimento explícito do usuário",
                "ro": "Companii care utilizează consimțământul explicit al utilizatorului",
                "ru": "Компании, использующие пользовательское соглашение",
                "sv": "Leverantörer som använder uttryckligt samtycke från användaren",
                "sk": "Spoločnosti, ktoré používajú výslovný súhlas používateľa"
            },
            "defecto": "Empresas que utilizan el consentimiento explícito del usuario"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
